// removed by extract-text-webpack-plugin
module.exports = {"slideIn":"MobileNavDrawer__slideIn__e0ea7acc","slideOut":"MobileNavDrawer__slideOut__e0ea7acc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavDrawer/MobileNavDrawer.scss
// module id = ./src/components/MobileNav/MobileNavDrawer/MobileNavDrawer.scss
// module chunks = 4